"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOverlayRoot = void 0;
/**
 * 获取/创建浮层容器
 */
var inject_value_1 = require("./inject-value");
var rootId = "tea-overlay-root";
var root;
function getOverlayRoot(popupContainer) {
    if (popupContainer) {
        return inject_value_1.injectValue(popupContainer)();
    }
    if (typeof document === "object") {
        root = root || document.getElementById(rootId);
        if (!root) {
            root = document.createElement("div");
            root.id = rootId;
            document.body.appendChild(root);
        }
    }
    return root;
}
exports.getOverlayRoot = getOverlayRoot;
//# sourceMappingURL=get-overlay-root.js.map